import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import {
  noop,
  numberOrBlank,
  singleOrArray,
  stringOrFunction,
} from 'Helpers/PropTypes';

import NormalizedInput from '..';

const numberFormatProps = [
  'thousandSeparator',
  'decimalSeparator',
  'thousandsGroupStyle',
  'decimalScale',
  'fixedDecimalScale',
  'allowNegative',
  'allowEmptyFormatting',
  'prefix',
  'suffix',
  'value',
  'defaultValue',
  'isNumericString',
  'displayType',
  'disabled',
  'type',
  'format',
  'Or',
  'removeFormatting',
  'mask',
  'customInput',
  'onValueChange',
  'isAllowed',
  'renderText',
  'getInputRef',
  'placeholder',
];

class NumberInput extends Component {
  constructor(props) {
    super(props);

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleBlur() {
    const {
      max, min, name, onBlur, onChange, value,
    } = this.props;
    const newValue = value === '' || value === null
      ? value
      : Math.max(Math.min(value, max), min);
    if (value !== newValue) onChange(name, newValue);
    onBlur();
  }

  handleChange({ floatValue }) {
    const { name, onChange } = this.props;
    const value = floatValue === undefined ? '' : floatValue;
    onChange(name, value);
  }

  render() {
    const { handleBlur, handleChange, props } = this;
    const {
      className, isNumericOnly, min, test,
    } = this.props;
    let passAlong = {};

    numberFormatProps.forEach((key) => {
      if (key in props) {
        const obj = {};
        obj[key] = props[key];
        passAlong = Object.assign(passAlong, obj);
      }
    });

    return (
      <NormalizedInput>
        <NumberFormat
          {...passAlong}
          type={isNumericOnly ? 'tel' : 'text'}
          allowNegative={min < 0}
          className={`Number ${className}`}
          onBlur={handleBlur}
          onValueChange={handleChange}
          test={test}
        />
      </NormalizedInput>
    );
  }
}

NumberInput.propTypes = {
  className: PropTypes.string,
  decimalScale: PropTypes.number,
  format: stringOrFunction,
  mask: singleOrArray(PropTypes.string),
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  value: numberOrBlank,
  test: PropTypes.string,
  isNumericOnly: PropTypes.bool,
};

NumberInput.defaultProps = {
  className: '',
  decimalScale: undefined,
  format: undefined,
  mask: ' ',
  max: Number.POSITIVE_INFINITY,
  min: Number.NEGATIVE_INFINITY,
  onBlur: noop,
  onChange: noop,
  placeholder: '',
  prefix: undefined,
  suffix: undefined,
  value: '',
  test: '',
  isNumericOnly: false,
};

export default NumberInput;
